import apiClient from "@/services/api/apiClientStudent";
import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  loginStart,
  loginSuccess,
  loginFailure,
  logout,
} from "@store/slices/studentAuthSlice";
import { BASE_URL } from "@utils/constants";
import { jwtDecode } from "jwt-decode";

export const loginStudent = createAsyncThunk(
  "api/user/login",
  async (credentials, { dispatch }) => {
    try {
      console.log("BASE_URL:", BASE_URL);
      console.log("Login request to:", BASE_URL + "api/user/login");
      console.log("Credentials:", credentials);
      dispatch(loginStart());
      const response = await fetch(BASE_URL + "api/user/login", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          loginId: credentials.username,
          password: credentials.password,
          captchaToken: credentials.captchaToken,
          captchaInput: credentials.captchaInput,
        }),
      }).catch((error) => {
        console.error("Fetch error:", error.message, error);
        throw error;
      });

      console.log("Response status:", response.status);
      console.log("Response headers:", [...response.headers.entries()]);

      const data = await response.json();
      console.log("Response data:", data);

      if (data.status !== 'success') {
        throw new Error(data.message || "Login failed");
      }

      const authToken = data.data;
      if (authToken) {
        const decoded = jwtDecode(authToken);
        dispatch(
          loginSuccess({
            user: decoded.sub,
            role: decoded.roleName,
            token: authToken,
            userId: decoded.userId,
          })
        );
      } else {
        throw new Error("Authentication token not found in response");
      }
      return data.data;
    } catch (error) {
      console.error("Login error:", error.message, error.stack);
      dispatch(loginFailure(error.message));
      throw error;
    }
  }
);

export const logoutUser = () => async (dispatch, getState) => {
  const token = getState().studentAuth.token;

  console.log("token:", token);

  dispatch(logout());

  const requestOptions = {
    method: "POST",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };

  try {
    await fetch(BASE_URL + "api/user/logout", requestOptions);
  } catch (error) {
    console.log(error);
    return error;
  }
};


export const refreshTokenStudent = createAsyncThunk(
  "auth/refreshToken",
  async (_, { dispatch, getState }) => {
    try {
      const state = getState();
      const token = state.auth.token;
      console.log("Refresh token request to:", BASE_URL + "api/user/refresh-token");

      const response = await fetch(BASE_URL + "api/user/refresh-token", {
        method: "get",
        credentials: "include",
        headers: {
          "Authorization": `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }).catch((error) => {
        console.error("Fetch error:", error.message, error);
        throw error;
      });

      const data = await response.json();
      console.log("Refresh response data:", data);

      if (response.status !== 200 || data.status !== "success") {
        throw new Error(data.message || "Token refresh failed");
      }

      const authToken = data.data;
      if (!authToken) {
        throw new Error("Authentication token not found in response");
      }

      const decoded = jwtDecode(authToken);
      console.log("Decoded refresh JWT:", decoded);
      dispatch(
        loginSuccess({
          user: decoded.sub,
          role: decoded.roleName,
          token: authToken,
          userId: decoded.userId,
        })
      );
      return authToken;
    } catch (error) {
      console.error("Refresh token error:", error.message, error.stack);
      throw error;
    }
  }
);


// ------------------------------my profile thunks -------------------------------------------
export const fetchprofile = () => async (dispatch, getState) => {
  const state = getState();
  const { userId, token } = state.studentAuth;
  console.log("Fetching profile for userId:", userId);

  const requestOptions = {
    method: "GET",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      "Authorization": `Bearer ${getState().studentAuth.token}`,
    },
  };

  try {
    const response = await apiClient(
      BASE_URL + `api/user/profile?userId=${getState().studentAuth.userId}`,
      requestOptions
    );
    return response;
  } catch (error) {
    console.log(error);
    return error;
  }
};


export const updateprofile = (payload) => async (dispatch, getState) => {
  const state = getState();
  const { userId, token } = state.studentAuth;

  const requestOptions = {
    method: "PUT",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      "Authorization": `Bearer ${token}`,
    },
    body: JSON.stringify(payload),
  };

  try {
    const response = await apiClient(
      BASE_URL + `api/user/profile/update-fields?userId=${userId}`,
      requestOptions
    );
    return response;
  } catch (error) {
    console.log(error);
    return error;
  }
};



export const updatepassword = (payload) => async (dispatch, getState) => {
  const state = getState();
  const { userId, token } = state.studentAuth;

  const requestOptions = {
    method: "PUT",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      "Authorization": `Bearer ${token}`,
    },
    body: JSON.stringify(payload),
  };

  try {
    const response = await apiClient(
      BASE_URL + `api/user/profile/update-password?userId=${userId}`,
      requestOptions
    );
    return response;
  } catch (error) {
    console.log(error);
    return error;
  }
};


export const updateknownLanguage = (payload) => async (dispatch, getState) => {
  const state = getState();
  const { userId, token } = state.studentAuth;

  const requestOptions = {
    method: "PUT",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      "Authorization": `Bearer ${token}`,
    },
    body: JSON.stringify(payload),
  };

  try {
    const response = await apiClient(
      BASE_URL + `api/user/profile/update-languages?userId=${userId}`,
      requestOptions
    );
    return response;
  } catch (error) {
    console.log(error);
    return error;
  }
};


export const sendOTPForProfile = (type, payload) => async (dispatch, getState) => {
  const state = getState();
  const { userId, token } = state.studentAuth;

  const requestOptions = {
    method: "POST",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      "Authorization": `Bearer ${token}`,
    },
    body: JSON.stringify(payload),
  };

  try {
    const url = type === "email" ? `api/user/profile/sent-otp-email?userId=${userId}` : `api/user/profile/sent-otp-mobile?userId=${userId}`;
    const response = await apiClient(
      BASE_URL + url,
      requestOptions
    );
    return response;
  } catch (error) {
    console.log(error);
    return error;
  }
};


export const verifyOTPForProfile = (type, payload) => async (dispatch, getState) => {
  const state = getState();
  const { userId, token } = state.studentAuth;

  const requestOptions = {
    method: "POST",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      "Authorization": `Bearer ${token}`,
    },
    body: JSON.stringify(payload),
  };

  try {
    const url = type === "email" ? `api/user/profile/verify-email-otp?userId=${userId}` : `api/user/profile/verify-mobile-otp?userId=${userId}`;
    const response = await apiClient(
      BASE_URL + url,
      requestOptions
    );
    return response;
  } catch (error) {
    console.log(error);
    return error;
  }
};

export const verifyOTPForRegistration = (payload) => async (dispatch, getState) => {
  const state = getState();

  const requestOptions = {
    method: "POST",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(payload),
  };

  try {
    const url = `api/user/register/verify-otp`;
    console.log(BASE_URL+url)
    const response = await apiClient(
      BASE_URL + url,
      requestOptions
    );
    return response;
  } catch (error) {
    console.log(error);
    return error;
  }
};
